import React, { useEffect, useState } from "react";
import "../../modal.css";

export default function TravelModal({ CloseChat, handleSubmit, handleClosePop, selectOption, openModal, option }) {
  return (

    <div id="popup1" className={`overlay  ${openModal}`}>
      <div className="chatpopup">
        <div className="feedback-share">
          <div className="heading">Overall, how would you rate your chat experience?</div>
          <div onClick={handleClosePop} className="closeIcon">&#x2715;</div>
          <div className="feedback-box">
            <input type="radio" name="select" id="option-1" />
            <input type="radio" name="select" id="option-2" />
            <label for="option-1" className={`option option-1 ${option === 'Good' ? "active" : ""}`} onClick={() => selectOption("Good")}>
              <div className="dot good"></div>
              <span>Good</span>
            </label>
            <label for="option-2" className={`option option-2 ${option === 'Bad' ? "active" : ""}`} onClick={() => selectOption("Bad")}>
              <div className="dot bad"></div>
              <span>Bad</span>
            </label>
          </div>
          {/* <textarea onChange={(event) => handleChange(event.target.value)} placeholder="Please Enter Your Feedback">
          </textarea> */}

          <a className="btn" onClick={() => handleSubmit()}>Submit feedback</a>
          <a href="javascript:void(0)" onClick={() => handleSubmit()} className="close">close</a>
        </div>


      </div>
    </div>
  );
}
